import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';

//import BottomNavigation from '@material-ui/core/BottomNavigation';
//import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
//import FolderIcon from '@material-ui/icons/Folder';

import ReactTooltip from "react-tooltip"

const useStyles = makeStyles({
  root: {
    width: '100%',
    position:'fixed',
    bottom:0,
    //backgroundColor:'blue',
    //padding:'10px',
    height:'100px',
    zIndex:1000,
    marginLeft:'-10px',
    overflowX:'hidden',
  },
  buttonContainer:{
    display:'flex',
    flexDirection:'row',
    justifyContent:'center',
  },
  hoverable: {
    backgroundColor: 'rgba(255,255,255,0)!important',
    '&:hover': {
      cursor: 'pointer',
    },
    minHeight: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '5px 10px',
  },
  imageContainer: {
    //position:'absolute',
    //border:'1px solid black',
    width: '60px',
    height: '60px',
    borderRadius: '5px',
    //clipPath: 'circle(35px at 50% 50%)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  selectorImage: {
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center!important',
    width: '40px',
    height: '40px',
  },
  solar: {
    backgroundImage: 'url("/images/vea_selected_energy/solar_white.svg")',
  },
  windOnshore: {
    backgroundImage: 'url("/images/vea_selected_energy/onshoreWind_white.svg")',
  },

  windOffshore: {
    backgroundImage: 'url("/images/vea_selected_energy/offshoreWind_white.svg")',
  },

  toolTip: {
    textAlign: 'left',
    color: '#00000!important',
    backgroundColor: '#aaaaaa',
    fontFamily: 'Flanders Art Sans!important',
  },
  //selected:{
  //  paddingTop:'16px!important',
  //},
  //label:{
  //  paddingTop:'6px!important',
  //},
});

export default function VeaBottomNavigation(props) {
  const classes = useStyles();
  const [value, setValue] = React.useState('solar');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let textTooltipSolar
  let textTooltipWindOnshore
  let textTooltipWindOffshore
  //let suggestionText

  switch (props.lang) {
    case "de":
      textTooltipSolar = "Solar panels"
      textTooltipWindOnshore = "Wind turbines onshore"
      textTooltipWindOffshore = "Wind turbines offshore"
      //suggestionText= 'Click the buttons to choose the energy source' 
      break
    case "en":
      textTooltipSolar = "Solar panels"
      textTooltipWindOnshore = "Wind turbines onshore"
      textTooltipWindOffshore = "Wind turbines offshore"
      //suggestionText= 'Click the buttons to choose the energy source' 
      break
    case "fr":
      textTooltipSolar = "Panneaux solaires"
      textTooltipWindOnshore = "Turbines éoliennes onshore"
      textTooltipWindOffshore = "Turbines éoliennes offshore"
      //suggestionText= 'Cliquez les boutons on ou off à choisir la source d\'énergie' 
      break
    case "nl":
    default:
      textTooltipSolar = "Zonnepanelen"
      textTooltipWindOnshore = "Windturbines onshore"
      textTooltipWindOffshore = "Windturbines offshore"
      //suggestionText= 'Cliquez les boutons on ou off à choisir la source d\'énergie' 
      break
  }

  const tooltipSolar =
    <ReactTooltip id='solar_tooltip' type='light' place='right' className={classes.toolTip}>
      <p>{textTooltipSolar}</p>
    </ReactTooltip>

  const tooltipWindOnshore =
    <ReactTooltip id='wind_onshore_tooltip' type='light' place='right' className={classes.toolTip}>
      <p>{textTooltipWindOnshore}</p>
    </ReactTooltip>

  const tooltipWindOffshore =
    <ReactTooltip id='wind_offshore_tooltip' type='light' place='left' className={classes.toolTip}>
      <p>{textTooltipWindOffshore}</p>
    </ReactTooltip>


  const solarIcon = (
    <div className={classes.hoverable}>
      <div className={classes.imageContainer + (props.currentTech.solar ? " bgdarkyellow" : " bgmediumgrey")}>
        <div
          className={classes.selectorImage + " " + classes.solar}
          data-for='solar_tooltip'
          data-tip='solar_tooltip'
          data-energy_source='solar'
          onClick={props.setEnergySource}
        >
        </div>

      </div>
      {/*tooltipSolar*/}
    </div>
  );
  const onshoreIcon = (
    <div className={classes.hoverable}>
      <div className={classes.imageContainer + (props.currentTech.wind ? " bgdarkblue" : " bgmediumgrey")}>
        <div
          className={classes.selectorImage + " " + classes.windOnshore}
          data-for='wind_onshore_tooltip'
          data-tip='wind_onshore_tooltip'
          data-energy_source='wind'
          onClick={props.setEnergySource}
        >
        </div>

      </div>
      {/*tooltipWindOnshore*/}
    </div>
  );
  const offshoreIcon = (
    <div className={classes.hoverable}>
      <div className={classes.imageContainer + (props.currentTech.windOffshore ? " bgbrightblue" : " bgmediumgrey")}>
        <div
          className={classes.selectorImage + " " + classes.windOffshore}
          data-for='wind_offshore_tooltip'
          data-tip='wind_offshore_tooltip'
          data-energy_source='windOffshore'
          onClick={props.setEnergySource}
        >
        </div>

      </div>
      {/*ooltipWindOffshore*/}
    </div>
  );
  
  /*
  return (
    
    <BottomNavigation 
      value={value} 
      showLabels={false} 
      onChange={handleChange} 
      className={classes.root}
    >
      <BottomNavigationAction 
        label="Solar" 
        showLabel={false} 
        value="solar" icon={solarIcon} 
        classes={{selected:classes.selected,label:classes.label}}
      />
      <BottomNavigationAction label="Onshore" value="windonshore" icon={onshoreIcon} />
      <BottomNavigationAction label="Offshore" value="windoffshore" icon={offshoreIcon} />
      <BottomNavigationAction label="Mode" value="mode" icon={<FolderIcon />} />
    </BottomNavigation>
    );
    */

  return (
    <Grid item xs={12} 
      className={classes.root + ' bgdarkbluegreen'}
    >
      <Grid item xs={12} style={{color:'white',marginTop:'5px'}}>Kies uw energiebron</Grid>
      <Grid item className={classes.buttonContainer}>
      {solarIcon}
      {onshoreIcon}
      {offshoreIcon}
      </Grid>
    </Grid>
  );
}